/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteTagDtoModel, RouteTagDtoModelType } from "./RouteTagDtoModel"
import { RouteTagDtoModelSelector } from "./RouteTagDtoModel.base"
import { RouteTemplateConstraintCapacityDtoModel, RouteTemplateConstraintCapacityDtoModelType } from "./RouteTemplateConstraintCapacityDtoModel"
import { RouteTemplateConstraintCapacityDtoModelSelector } from "./RouteTemplateConstraintCapacityDtoModel.base"
import { RouteTemplatesConstraintLocationDtoModel, RouteTemplatesConstraintLocationDtoModelType } from "./RouteTemplatesConstraintLocationDtoModel"
import { RouteTemplatesConstraintLocationDtoModelSelector } from "./RouteTemplatesConstraintLocationDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  capacities: IObservableArray<RouteTemplateConstraintCapacityDtoModelType>;
}

/**
 * RouteTemplatesConstraintDtoBase
 * auto generated base class for the model RouteTemplatesConstraintDtoModel.
 */
export const RouteTemplatesConstraintDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteTemplatesConstraintDto')
  .props({
    __typename: types.optional(types.literal("RouteTemplatesConstraintDto"), "RouteTemplatesConstraintDto"),
    id: types.identifier,
    routeTemplateId: types.union(types.undefined, types.number),
    capacity: types.union(types.undefined, types.null, types.number),
    capacities: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => RouteTemplateConstraintCapacityDtoModel)))),
    startTime: types.union(types.undefined, types.null, types.string),
    endTime: types.union(types.undefined, types.null, types.string),
    duration: types.union(types.undefined, types.null, types.number),
    startLocations: types.union(types.undefined, types.null, types.array(types.late((): any => RouteTemplatesConstraintLocationDtoModel))),
    endLocations: types.union(types.undefined, types.null, types.array(types.late((): any => RouteTemplatesConstraintLocationDtoModel))),
    tags: types.union(types.undefined, types.null, types.array(types.late((): any => RouteTagDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteTemplatesConstraintDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeTemplateId() { return this.__attr(`routeTemplateId`) }
  get capacity() { return this.__attr(`capacity`) }
  get startTime() { return this.__attr(`startTime`) }
  get endTime() { return this.__attr(`endTime`) }
  get duration() { return this.__attr(`duration`) }
  capacities(builder: string | RouteTemplateConstraintCapacityDtoModelSelector | ((selector: RouteTemplateConstraintCapacityDtoModelSelector) => RouteTemplateConstraintCapacityDtoModelSelector) | undefined) { return this.__child(`capacities`, RouteTemplateConstraintCapacityDtoModelSelector, builder) }
  startLocations(builder: string | RouteTemplatesConstraintLocationDtoModelSelector | ((selector: RouteTemplatesConstraintLocationDtoModelSelector) => RouteTemplatesConstraintLocationDtoModelSelector) | undefined) { return this.__child(`startLocations`, RouteTemplatesConstraintLocationDtoModelSelector, builder) }
  endLocations(builder: string | RouteTemplatesConstraintLocationDtoModelSelector | ((selector: RouteTemplatesConstraintLocationDtoModelSelector) => RouteTemplatesConstraintLocationDtoModelSelector) | undefined) { return this.__child(`endLocations`, RouteTemplatesConstraintLocationDtoModelSelector, builder) }
  tags(builder: string | RouteTagDtoModelSelector | ((selector: RouteTagDtoModelSelector) => RouteTagDtoModelSelector) | undefined) { return this.__child(`tags`, RouteTagDtoModelSelector, builder) }
}
export function selectFromRouteTemplatesConstraintDto() {
  return new RouteTemplatesConstraintDtoModelSelector()
}

export const routeTemplatesConstraintDtoModelPrimitives = selectFromRouteTemplatesConstraintDto().routeTemplateId.capacity.startTime.endTime.duration
